// import { createContext, useContext, useState } from "react";

// const CartContext = createContext();

// export const CartProvider = ({ children }) => {
//   const [cartCount, setCartCount] = useState(0);
//  const [showLogin, setShowLogin] = useState(false);
//   const [redirectAfterLogin, setRedirectAfterLogin] = useState(null);
//   return (
//     <CartContext.Provider
//      value={{ cartCount,
//        setCartCount ,
//       showLogin,
//         setShowLogin,
//         redirectAfterLogin,
//         setRedirectAfterLogin
//     }}>
//       {children}
//     </CartContext.Provider>
//   );
// };

// export const useCart = () => useContext(CartContext);






import { createContext, useContext, useState, useEffect } from "react";
import axios from "axios";

const CartContext = createContext();

export const CartProvider = ({ children }) => {
  const [cartCount, setCartCount] = useState(() => {
    return Number(localStorage.getItem("cart_count")) || 0;
  });

  const [showLogin, setShowLogin] = useState(false);
  const [redirectAfterLogin, setRedirectAfterLogin] = useState(null);

  useEffect(() => {
    const loadCartCount = async () => {
      const userId = sessionStorage.getItem("userId");
      const cartToken = localStorage.getItem("cart_token");

      if (!userId && !cartToken) return;

      try {
        const res = await axios.post(
          "https://ecom.cyberathon.com/index.php/Api/list_cart",
          {
            user_id: userId || null,
            cart_token: userId ? null : cartToken,
          }
        );

        if (res.data.status) {
          const count = res.data.cart_items.length;
          setCartCount(count);
          localStorage.setItem("cart_count", count);
        }
      } catch (e) {
        console.error("Cart count load failed", e);
      }
    };

    loadCartCount();
  }, []);

  return (
    <CartContext.Provider
      value={{
        cartCount,
        setCartCount,
        showLogin,
        setShowLogin,
        redirectAfterLogin,
        setRedirectAfterLogin
      }}
    >
      {children}
    </CartContext.Provider>
  );
};

export const useCart = () => useContext(CartContext);